module.exports = __webpack_public_path__ + "img/emoji-26.df442333.png";